"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.split");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getAmountAndDecimalPart = function getAmountAndDecimalPart(value, symbolPosition) {
  if (!value) {
    return {};
  }

  var _String$split = String(value).split('.'),
      basicAmount = _String$split[0],
      decimal = _String$split[1];

  var amount = Math.abs(Number(basicAmount)).toLocaleString();

  if (symbolPosition === 'start') {
    return {
      amount: amount,
      decimal: decimal
    };
  }

  if (decimal) {
    return {
      amount: amount + "." + decimal
    };
  }

  return {
    amount: amount
  };
};

var propTypes = {
  center: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  label: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(['small', 'large']),
  symbol: _propTypes["default"].string,
  symbolPosition: _propTypes["default"].oneOf(['start', 'end']),
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
var defaultProps = {
  center: false,
  symbolPosition: 'start'
};

var HeroNumber = function HeroNumber(_ref) {
  var value = _ref.value,
      symbol = _ref.symbol,
      label = _ref.label,
      size = _ref.size,
      center = _ref.center,
      className = _ref.className,
      symbolPosition = _ref.symbolPosition,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["value", "symbol", "label", "size", "center", "className", "symbolPosition"]);

  var containerClasses = (0, _classnames["default"])('grv-hero-numbers__container', className);
  var numbersClasses = (0, _classnames["default"])('grv-hero-numbers', {
    'grv-hero-numbers--center': center,
    'grv-hero-numbers--large': size === 'large',
    'grv-hero-numbers--small': size === 'small'
  });
  var labelClasses = (0, _classnames["default"])('grv-hero-numbers__label', {
    'grv-hero-numbers__label--center': center,
    'grv-hero-numbers__label--large': size === 'large',
    'grv-hero-numbers__label--small': size === 'small'
  });

  var _getAmountAndDecimalP = getAmountAndDecimalPart(value, symbolPosition),
      amount = _getAmountAndDecimalP.amount,
      decimal = _getAmountAndDecimalP.decimal;

  var negative = value < 0;
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, otherProps, {
    className: containerClasses
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: numbersClasses
  }, negative ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "grv-hero-numbers__negative"
  }, "-") : null, symbolPosition !== 'end' ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "grv-hero-numbers__symbol"
  }, symbol) : null, amount ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "grv-hero-numbers__amount"
  }, amount) : null, symbolPosition !== 'end' && decimal ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "grv-hero-number__decimal-point"
  }, ".") : null, decimal ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "grv-hero-numbers__decimal"
  }, decimal) : null, symbolPosition === 'end' ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "grv-hero-numbers__symbol"
  }, symbol) : null), /*#__PURE__*/_react["default"].createElement("p", {
    className: labelClasses
  }, label));
};

HeroNumber.propTypes = propTypes;
HeroNumber.defaultProps = defaultProps;
var _default = HeroNumber;
exports["default"] = _default;